import React from 'react';
import { Box, Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { DiscussionMain } from './DiscussionMain';

const getStyles = makeStyles((theme) => ({
  introText: {
    opacity: 0.6,
    fontStyle: 'italic',
  },
  img: {
    maxWidth: '100%',
  },
}));

export const DiscussionDashboard = (props) => {
  const classes = getStyles();
  return (
    <Box>
      <Container maxWidth="lg">
        {window.SETTINGS.FORUM_HEAD_IMG && (
          <Box align="center">
            <img className={classes.img} src={window.SETTINGS.FORUM_HEAD_IMG} />
          </Box>
        )}
        <Box align="center" pt={1}>
          <Typography variant="body2" className={classes.introText}>
            {window.LANG.FORUM_HEADLINE}
          </Typography>
        </Box>
      </Container>
      <DiscussionMain {...props} />
    </Box>
  );
};

DiscussionDashboard.displayName = 'DiscussionDashboard';
